import styled from 'styled-components';

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  padding: 5% 10% 5% 10%;
`;

export const ContentContainer = styled.div`
  display: flex;
  flex: 1;
  margin-top: 2%;
  align-items: center;
  justify-content: center;
  flex-direction: column;
`;